import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { SocialMediaSlugs } from '../consts';
import { UsageTracker } from '../utils/tracking';
import SocialIcon from './Icons/SocialIcon';

const BlankComponent = () => null;

const SocialLink = ({
  socialMediaName,
  socialMediaId
}) => {
  const trackClick = useCallback(() => {
    UsageTracker.trackInteraction({
      action: 'Social link clicked',
      name: socialMediaName
    });
  }, [socialMediaName]);
  if (!socialMediaId) return null;
  return /*#__PURE__*/_jsx(UITooltip, {
    title: `${SocialMediaSlugs[socialMediaName]}${socialMediaId}`,
    maxWidth: "100%",
    placement: "bottom",
    children: /*#__PURE__*/_jsx(UILink, {
      href: `https://${SocialMediaSlugs[socialMediaName]}${socialMediaId}`,
      use: "unstyled",
      external: true,
      ExternalIcon: BlankComponent,
      className: "m-right-2",
      onClick: trackClick,
      children: /*#__PURE__*/_jsx(SocialIcon, {
        className: "m-right-0",
        socialMediaName: socialMediaName
      })
    })
  });
};

export default SocialLink;